// 认证相关API
import axios from "axios";
import { toAuthRequestError } from "../../utils/rateLimit";

// 创建一个不带拦截器的axios实例，用于token刷新等认证操作
const authInstance = axios.create({
    baseURL: window.location.origin,
    timeout: 30000,
});

// 响应拦截器 - 只处理数据格式，不处理token相关逻辑
authInstance.interceptors.response.use(
    (res) => {
        return res.data;
    },
    (err) => {
        // 保留状态码与 Retry-After，供 tokenManager 区分刷新失败的类型（#897）
        return Promise.reject(
            toAuthRequestError(
                err,
                err?.response?.data?.error ||
                    err?.response?.data?.err ||
                    err?.response?.data?.message ||
                    err?.response?.data?.auth ||
                    err?.response?.data?.msg ||
                    "请求错误"
            )
        );
    }
);

const authApi = {
    // 刷新token
    refreshToken: (refreshToken: string) =>
        authInstance({
            url: "/auth/token/refresh",
            method: "post",
            data: { refresh_token: refreshToken },
        }),

    // 退出登录
    signout: (refreshToken: string) =>
        authInstance({
            url: "/auth/signout",
            method: "post",
            data: { refresh_token: refreshToken },
        }),
};

export default authApi;
